<template>
  <div>
    <!-- Modal Usuário -->
    <div
      class="modal fade"
      id="modalVisualizar"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalVisualizarTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalVisualizarTitle">Visualizar Usuário</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-10">
                <form action>
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userName">Nome do Usuário</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userName"
                          :value="
                              dataModal.user
                                .name
                            "
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userMail">Email do Usuário</label>
                        <input
                          type="email"
                          class="form-control"
                          id="userMail"
                          :value="
                              dataModal.user
                                .email
                            "
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userPhone">Celular do Usuário</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userPhone"
                          :value="
                              dataModal.user
                                .cellphone
                            "
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userCNH">Número da CNH</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userCNH"
                          :value="
                              dataModal.user
                                .number_cnh
                            "
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userCateg">Categoria da CNH</label>
                        <input
                          type="text"
                          class="form-control"
                          id="userCateg"
                          :value="
                              dataModal.user
                                .cat_cnh
                            "
                          disabled
                        />
                      </div>
                    </div>
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="userDateTo">Data de Validade da CNH</label>
                        <input
                          type="date"
                          class="form-control"
                          id="userDateTo"
                          placeholder
                          value="2020-05-25"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-2">
                <div class="user-img">
                  <img
                    class="user"
                    :src="
                        dataModal.user.photo
                      "
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: ["modalStatus", "dataModal"],

  data() {
    return {};
  },
  watch: {
    modalStatus: function(newStatus) {
      if (newStatus == true) {
        this.startModal();
      }
    }
  },
  computed: {},
  mounted() {
    if (this.modalStatus == true) {
      this.startModal();
    }
  },
  methods: {
    openModal(object) {
      this.$emit("OMDCk", object);
    },
    notificationLate(user_id, devolution_date) {
      const self = this;
      let api = self.$store.state.api + "notifications/late";

      let fd = new FormData();

      fd.append("devolution_date", devolution_date);
      fd.append("user_id", user_id);

      self.$http
        .post(api, fd)
        .then(response => {
          self.$message(
            "Sucesso",
            `Notificação enviada com sucesso!`,
            "success"
          );
          self.getChecklistItems();
        })
        .catch(error => {
          self.$message(null, error.response.data, "error");
        });
    },
    startModal() {
      this.clean();
      $("#modalVisualizar").modal("toggle");
    },
    clean() {
      this.$emit("changeModal", false);
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Modals/UserModal.vue